import { isValidSecurityCode } from '../../../../shared/validators/isValidSecurityCode.js';
import { getOtpAccessView, getOtpAccessBtnSubmit, showOtpAccessError, hideOtpFields, focusInputCode } from './getOtpAccessView.js';
import { registerSession } from '../../api/registerSession.js';
import { onRegisterSession } from '../onRegisterSession.js';
import { recoverSecurityOtp } from '../../api/recoverSecurityOtp.js';
import progressBar from '../../../../shared/DOM/progressBar.js';
import { disableLanguage } from '../../../../shared/DOM/disableLanguage.js';
import { getTargetViewName } from '../../../../shared/DOM/getTargetViewName.js';
import { getLinkFooter } from '../getLinkFooter.js';

export function renderOtpAccess(registerData) {
  const isOtpStep = document.getElementById('container-form').getAttribute('otpStep');
  const eForm = document.getElementById('form-login');

  // 12/2023: Incluímos user y pass para el remember
  eForm.render({
    value: {
      user: registerData.user,
      password: registerData.password,
    },
    view: getOtpAccessView(isOtpStep),
  });

  createOtpAccessFooter();

  // #activate
  hideOtpFields(isOtpStep);

  initOtpAccess();

  /////////////////////////////

  function initOtpAccess() {
    disableLanguage();

    eForm.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' && !!getOtpAccessBtnSubmit()) {
        submitOtpAccessForm();
      }
    });

    document.body.addEventListener('click', (event) => {
      const target = getTargetViewName(event);

      if (target === 'btnOtpAccess') {
        submitOtpAccessForm();
      } else if (target === 'linkRecoverOtp') {
        linkRecoverOtp();
      }
    });
  }

  // eBtnSubmit
  async function submitOtpAccessForm() {
    const eBtnSubmit = getOtpAccessBtnSubmit();

    if (!eBtnSubmit || eBtnSubmit.state === 'loading') {
      return;
    }

    try {
      eBtnSubmit.state = 'loading';
      progressBar.loading();

      const { code } = eForm.value;

      // eForm.valid personalizado
      const valid = isValidSecurityCode(code);

      // Exit error
      if (!valid) {
        throw new Error('login.otpcode_invalid');
      }

      // set security code
      registerData.seccode = code;

      const tokena = await registerSession(registerData);
      if (tokena) {
        // 12/2023: En el otp devolver o no el form depende de si hemos accedido directo de algún otpStep
        await onRegisterSession(registerData, tokena, isOtpStep ? null : document.forms['login']);
      }
      // else no token + no error > navigateTo

      // Finalizamos correctamente por si navegan hacia atrás en el navegador:
      progressBar.resolved();
      // Con retardo para visualizar solo el check de ok
      setTimeout(() => {
        eBtnSubmit.state = 'resolved';
      }, 1000);
    } catch (e) {
      eBtnSubmit.state = 'rejected';
      progressBar.rejected();
      showOtpAccessError(e.message);
    }
  }

  // Link
  async function linkRecoverOtp() {
    const link = document.body.querySelector('a[view-name="linkRecoverOtp"]');

    if (!link || link.hasAttribute('disabled')) {
      return;
    }

    try {
      link.setAttribute('disabled', '');
      progressBar.loading();

      await executeRecoverOtp(registerData);
      onExecuteRecoverOtp();

      progressBar.resolved();
    } catch (e) {
      progressBar.rejected();
      link.removeAttribute('disabled');

      showOtpAccessError(e.message);
    }
  }
}

function createOtpAccessFooter(showRecoverOtp) {
  document.getElementById('container-footer').innerHTML = showRecoverOtp !== false ? getLinkFooter('linkRecoverOtp', 'login.recover_otp') : '';
}

function showRecoverOTPMessage() {
  document.getElementById('container-form').insertAdjacentHTML(
    'afterbegin',
    `<div style="margin-bottom:16px;"><ewc-alert icon="circle-check" type="success" label="${edicom.locale.translate('login.recover_otp')}">
     <div style="white-space:normal">${edicom.locale.translate('login.ok_recoverOtp.1')}<br/>${edicom.locale.translate('login.ok_recoverOtp.2')}</div>
   </ewc-alert></div>`
  );
}

async function executeRecoverOtp({ user, domain, group }) {
  const ediwinResult = await recoverSecurityOtp({
    user,
    domain,
    group,
  });

  if (ediwinResult?.result !== 1) {
    throw new Error('login.error_sendCredentials');
  }
}

// Cambiamos un poco el concepto:
// Dejamos una banda para no olvidar que el código a introducir es el enviado y ya no mostramos más el link
function onExecuteRecoverOtp() {
  showRecoverOTPMessage();
  createOtpAccessFooter(false);
  focusInputCode();
}
